var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable } from 'rxjs/Rx';
import { MixpanelService } from './mixpanel/mixpanel.service';
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './localstorage.service';
import { OrderService } from './order/order.service';
import { CurrentOrderService } from './order/currentOrder.service';
// little hack to make jquery with metis menu work
// var jQuery = require('jquery');
// window.jQuery = jQuery;
// var metisMenu = require('metismenu');
var $ = require('jquery');
global.jQuery = $;
require('metismenu');
var AppComponent = (function () {
    function AppComponent(router, slimLoadingBarService, translate, mixpanelService, localStorage, orderService, currentOrderService) {
        var _this = this;
        this.router = router;
        this.slimLoadingBarService = slimLoadingBarService;
        this.translate = translate;
        this.mixpanelService = mixpanelService;
        this.localStorage = localStorage;
        this.orderService = orderService;
        this.currentOrderService = currentOrderService;
        $('#favicon').attr("href", require('../less/assets/images/favicon.png'));
        this.redirectToHttps();
        this.router.events.subscribe(function (event) {
            _this.navigationInterceptor(event);
        });
        this.setPreferedLanguage();
        this.CSPreProdEnvFeedback();
        this.getQRCode();
    }
    AppComponent.prototype.ngOnInit = function () {
        this.mixpanelService.api.unregister("FIRST_TIME");
        this.mixpanelService.api.track('App opened');
        $(".sideNavigation").metisMenu();
        $(window).bind("load resize scroll", function () {
            if (!$("body").hasClass('body-small')) {
                var heightWithoutNavbar = $("body > #wrapper").height() - 61;
                $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");
                var navbarHeigh = $('nav.navbar-default').height();
                var wrapperHeigh = $('#page-wrapper').height();
                if (navbarHeigh > wrapperHeigh) {
                    $('#page-wrapper').css("min-height", navbarHeigh + "px");
                }
                if (navbarHeigh < wrapperHeigh) {
                    $('#page-wrapper').css("min-height", $(window).height() + "px");
                }
                if ($('body').hasClass('fixed-nav')) {
                    if (navbarHeigh > wrapperHeigh) {
                        $('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
                    }
                    else {
                        $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
                    }
                }
            }
        });
        // Move right sidebar top after scroll
        $(window).scroll(function () {
            if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
                $('#right-sidebar').addClass('sidebar-top');
            }
            else {
                $('#right-sidebar').removeClass('sidebar-top');
            }
        });
        // Minimalize menu when screen is less than 768px
        $(window).on("load resize", function () {
            if ($(document).width() < 961) {
                $('body').addClass('body-small');
            }
            else {
                $('body').removeClass('body-small');
                $('body').removeClass('mini-navbar');
            }
        });
    };
    AppComponent.prototype.getQRCode = function () {
        var _this = this;
        // http://localhost:3000/?QR=eyJvcmRlciI6Ijc4IiwicGFydCI6Ijk4MDgwMi1ELU0yNjA2LTEifQ==
        // https://uptimedv.ptchornos.com?QR=https://uptimedv.ptchronos.com/?QR=eyJwYXJ0IjoiOTIxNjJWLTMiLCJvcmRlciI6IjM0OCJ9
        var param = this.getParameterByName('QR');
        if (!param)
            return;
        var part = JSON.parse(window.atob(param))['part'];
        var order = JSON.parse(window.atob(param))['order'];
        console.log("part# : ", part, " order# : ", order);
        this.orderService.getOrder(order).subscribe(function (data) {
            console.log(data);
            for (var i = 0; i < data.Items.length; i++) {
                if (data.Items[i].PartNumber == part) {
                    var p = data.Items[i];
                    data.Items = [];
                    data.Items.push(p);
                    break;
                }
            }
            data.PurchaseOrderNumber = "";
            data.ShippingAddress.Country.Id = "8b8b29a8-0e25-40fa-9004-8482c49daa5f"; //canada
            _this.currentOrderService.setOrder(data);
            _this.router.navigate(['/order/part']);
        });
    };
    AppComponent.prototype.setPreferedLanguage = function () {
        var languages = /en|fr|pt|de|es|it|nl/;
        if (window.location.hostname != "uptime.ptchronos.com") {
            languages = /en|fr|pt|de|es|it|nl|ach/;
        }
        this.translate.setDefaultLang('en');
        var queryLang = this.getParameterByName('lang');
        if (queryLang) {
            queryLang = queryLang.match(languages) ? queryLang : 'en';
            this.translate.use(queryLang);
            this.translate.currentLang = queryLang;
        }
        else {
            try {
                if (this.localStorage.getItem("preferedLanguage")) {
                    this.translate.use(this.localStorage.getItem("preferedLanguage"));
                    this.translate.currentLang = this.localStorage.getItem("preferedLanguage");
                }
                else {
                    var browserLang = (navigator.language || navigator.browserLanguage).split('-')[0];
                    browserLang = browserLang.match(languages) ? browserLang : 'en';
                    this.translate.use(browserLang);
                    this.translate.currentLang = browserLang;
                }
            }
            catch (e) {
                var browserLang = (navigator.language || navigator.browserLanguage).split('-')[0];
                browserLang = browserLang.match(languages) ? browserLang : 'en';
                this.translate.use(browserLang);
                this.translate.currentLang = browserLang;
            }
        }
        if (this.translate.currentLang == 'ach')
            this.startTranslation();
    };
    AppComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var waitForZopim = setInterval(function () {
            if (window.$zopim === undefined || window.$zopim.livechat === undefined) {
                return;
            }
            window.$zopim.livechat.setOnConnected(function () {
                window.$zopim.livechat.setLanguage(_this.translate.currentLang);
                window.$zopim.livechat.window.show();
                window.$zopim.livechat.window.toggle();
                window.$zopim.livechat.addTags("lan_" + _this.translate.currentLang);
            });
            clearInterval(waitForZopim);
        }, 25);
    };
    AppComponent.prototype.getParameterByName = function (name) {
        var url = window.location.href;
        name = name.replace(/[[]]/g, "\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/[+]/g, " "));
    };
    // private fix_height(): void {
    //   var heightWithoutNavbar = $("body > #wrapper").height() - 61;
    //   $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");
    //   var navbarHeigh = $('nav.navbar-default').height();
    //   var wrapperHeigh = $('#page-wrapper').height();
    //   if (navbarHeigh > wrapperHeigh) {
    //     $('#page-wrapper').css("min-height", navbarHeigh + "px");
    //   }
    //   if (navbarHeigh < wrapperHeigh) {
    //     $('#page-wrapper').css("min-height", $(window).height() + "px");
    //   }
    //   if ($('body').hasClass('fixed-nav')) {
    //     if (navbarHeigh > wrapperHeigh) {
    //       $('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
    //     } else {
    //       $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
    //     }
    //   }
    // }
    AppComponent.prototype.navigationInterceptor = function (event) {
        if (event instanceof NavigationStart) {
            this.slimLoadingBarService.start(function () {
                console.log('Loading complete');
            });
            window.scroll(0, 0);
        }
        if (event instanceof NavigationEnd) {
            this.slimLoadingBarService.complete();
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.slimLoadingBarService.stop();
        }
        if (event instanceof NavigationError) {
            this.slimLoadingBarService.stop();
            var title = this.translate.get('Error');
            var text = this.translate.get('An error occured. Please try again.');
            Observable.forkJoin(title, text).subscribe(function (res) {
                swal({
                    title: res[0],
                    text: res[1],
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                });
            });
        }
    };
    AppComponent.prototype.CSPreProdEnvFeedback = function () {
        if (window.location.hostname == 'uptimepp.ptchronos.com') {
            $("head").append('<script type="text/javascript" src="https://premiertechdigital.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/b856ck/b/c/7ebd7d8b8f8cafb14c7b0966803e5701/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en&collectorId=2b745f15"></script>');
        }
    };
    AppComponent.prototype.startTranslation = function () {
        var src = '<script type="text/javascript">var _jipt = [];_jipt.push(["project", "uptime"]);' +
            '_jipt.push(["escape", function() { window.location.href = "/?lang=en";}]);</script>' +
            '<script type="text/javascript" src="//cdn.crowdin.com/jipt/jipt.js"></script>';
        $("body").append(src);
    };
    AppComponent.prototype.redirectToHttps = function () {
        if (window.location.hostname != "localhost" && !window.location.href.startsWith("https://"))
            window.location.href = 'https://' + window.location.hostname;
    };
    AppComponent = __decorate([
        Component({
            selector: 'cx-app',
            templateUrl: './app.component.html',
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [Router,
            SlimLoadingBarService,
            TranslateService,
            MixpanelService,
            LocalStorageService,
            OrderService,
            CurrentOrderService])
    ], AppComponent);
    return AppComponent;
}());
export { AppComponent };
//# sourceMappingURL=app.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.js
// module id = 588
// module chunks = 0